import * as React from "react";
import { Choice } from "@cmsgov/design-system-core";

const SubSectionFields = ({
  fields,
  displayFields,
  detailSection,
  columns,
  onCheck,
  onRemoveCheck,
}: any) => {
  const SubSectionTitle = (
    <label className="filter-text-header ds-u-margin-top--1 ds-u-margin-bottom--2">
      {detailSection}
    </label>
  );

  if (fields.length > 0) {
    return (
      <div>
        {SubSectionTitle}
        {displaySelectAll({
          fields,
          displayFields,
          onCheck,
          onRemoveCheck,
        })}
        {mapFields({
          fields,
          displayFields,
          columns,
          onCheck,
          onRemoveCheck,
        })}
      </div>
    );
  } else {
    return (
      <div>
        {SubSectionTitle}
        <p>No Fields to Display</p>
      </div>
    );
  }
};

// TODO: Can this be refactored to use <MultiSelectCheckbox>?
const displaySelectAll = ({
  fields,
  displayFields,
  onCheck,
  onRemoveCheck,
}: any) => {
  // Check if all fields are checked from current display fields, if yes
  // add select all and make it checked
  const checkedFields = fields.filter((field: string) => {
    return displayFields.indexOf(field) !== -1;
  });
  const checked = checkedFields.length === fields.length;

  const handleCheck = (event: any) => {
    // Select all is checked
    // send all fields
    if (event.target.checked) {
      onCheck(fields);
    } else {
      onRemoveCheck(fields);
    }
  };

  return (
    <div className="drilldownCheckField">
      <input
        id="selectAll"
        type="checkbox"
        className="ds-c-choice ds-c-choice--small"
        checked={checked}
        onChange={handleCheck}
      />
      <label className="ds-c-label" htmlFor="selectAll">
        <span className="">Select All / None</span>
      </label>
    </div>
  );
};

const mapFields = ({
  fields,
  displayFields,
  columns,
  onCheck,
  onRemoveCheck,
}: any) => {
  const handleCheck = (event: any) => {
    const index = displayFields.indexOf(event.target.value);
    if (index === -1) {
      onCheck([event.target.value]);
    } else {
      onRemoveCheck([event.target.value]);
    }
  };
  const checkboxFields = fields.map((field: string) => {
    const checked = displayFields.indexOf(field) >= 0;
    const columnReferenceExists = columns && columns.hasOwnProperty(field);
    const displayTitle = columnReferenceExists ? columns[field].title : field;
    return (
      <Choice
        className="drilldownCheckField"
        key={field}
        size="small"
        name={`${field  }_choice`}
        value={field}
        onChange={handleCheck}
        checked={checked}
      >
        {displayTitle}
      </Choice>
    );
  });
  return checkboxFields;
};

export default SubSectionFields;
